import React, { useRef, useState } from "react";
import { useEffect } from "react";
import { useQuery } from "react-apollo";
import { Form } from "react-bootstrap";
import { DataSourceMapLayer } from "../../../deckgl/DataSourceMapLayer";
import { MapLayer } from "../../../deckgl/MapLayer";
import { useSoilHorizonDataSources } from "../../../hooks/useSoilHorizonDataSources";
import { DataSourceLayerMeta, DataSourceRasterLayer } from "../../../types/types";
import { getTileUrlTemplate } from "../../../../fields/utils/dataSourceUtils";
import Gradient from "../../../../../components/Gradient";
import { Definition } from "../../../../../data/Definition";
import { GET_SOIL_HORIZONS_BY_FIELD_ID } from "../../../../../queries";
import { SETTING_SEASON_YEAR } from "../../../utils/settings";
import { useStore } from "../../../providers/AppProvider";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog } from '@fortawesome/free-solid-svg-icons';
import { Button } from 'react-bootstrap';
import LayerSettings from "./LayerSettings";
import { Field, StatValue } from "../../../types/types";
import { queryDwSoilMaxMin } from "../../../utils/dwHelpers";
import { dcRound } from "../../../utils/misc";

import _ from 'lodash';
const uuidv4 = require('uuid/v4');

//const {settings, orgId} = useStore(); 

interface IProps {
    field: Field,
    rampWidth: number,
    addMapLayer: (layers: MapLayer) => void,
    refresh: () => void,
    fieldId: number | null,
    setSoilRasterDataSources: Function,
    setSoilRasterDataSourcesForExport?: Function,
    soilRasterDataSources: DataSourceRasterLayer[],
    setSoilRasterVisibility: Function,
    soilRasterVisibility: boolean,
    selectedSeason:string,
    setUpdateSoilsKey: Function,
    readyToLoadSoilHorizonData: boolean
    setReadyToLoadSoilHorizonData: Function,
    context?: string,
    horizonSelected: string | null,
    setHorizonSelected: Function
    propertySelected: string | null,
    setPropertySelected: Function
 };

const SoilDataSourceLayer = ({ field, rampWidth, addMapLayer, refresh, fieldId, soilRasterDataSources, setSoilRasterDataSources, 
    setSoilRasterDataSourcesForExport,
    setSoilRasterVisibility, soilRasterVisibility, selectedSeason, setUpdateSoilsKey, readyToLoadSoilHorizonData, setReadyToLoadSoilHorizonData, 
    context, horizonSelected, setHorizonSelected, propertySelected, setPropertySelected }: IProps) => {
    const [selected, setSelected] = useState<DataSourceRasterLayer | null>(null);
    const [visible, setVisible] = useState<boolean>(false);
    //const [horizonSelected, setHorizonSelected] = useState<string | null>(null);
    const [dataSourceInitialLoad, setDataSourceInitialLoad] = useState<boolean>(false);
    const [dataSourceMaxMinLoad, setDataSourceMaxMinLoad] = useState<boolean>(false);
    const [maxMinInitialLoad, setMaxMinInitialLoad] = useState<boolean>(false);
    const [horizons, setHorizons] = useState<any>({});
    const [dataSources, setDataSources] = useState<DataSourceRasterLayer[]>([]);
    const [dataSourcesUpdate, setDataSourcesUpdate] = useState<number>(0);
    const [horizonsMappingData, setHorizonsMappingData] = useState<any>(null);
    const [properties, setProperties] = useState<any | null>(null);
    const [gradientParameters, setGradientParameters] = useState<any>([[0,"rgb(255,255,255)"],[1,"rgb(0,0,0)"]]);
    const [horizonParameters, setHorizonParameters] = useState<any>([0,30]);
    const [unitParameters, setUnitParameters] = useState<any>(["",""]);
    const {state, settings, updateSettings } = useStore();
    const [year, setYear] = useState(settings[SETTING_SEASON_YEAR]);
    const [showLayerSettings, setShowLayerSettings] = useState(false);
    const [colorScaleRange, setColorScaleRange] = useState("field");

    useEffect(() => {
        setYear(settings[SETTING_SEASON_YEAR])
    }, [settings]);

    useEffect(() => {
        if (horizonsMappingData){
            setHorizonsMapping(horizonsMappingData);
        }
    }, [year]);

    useEffect(() => {
        console.log("100125 horizonSelected", horizonSelected);
        console.log("100125 propertySelected", propertySelected);
    }, [horizonSelected, propertySelected]);

    useEffect(() => {
        console.log("Z112723 soilRasterDataSources", soilRasterDataSources)
    }, [soilRasterDataSources]);

    const { localePreferences } = useStore();
    console.log("081825 localePreferences", localePreferences);
    const preferredAreaSmall = _.get(localePreferences, 'measureUnits.length.small.abbr');

    const vetProperties = ( _properties: any, _horizons1_2: any ) => {
        console.log("F112723 vetProperties > _properties", _properties)
        console.log("F112723 vetProperties > _horizons1_2", _horizons1_2)
        let refinedProperties = {};
        let orphanedProperties = {};
        Object.keys(_properties).forEach((_prop:any, _index:number) => {
            //console.log("F112723 _prop", _prop);
            //console.log("F112723", _properties[_prop].property_id, _properties[_prop].name);
            if (_horizons1_2.includes(_prop)){
                _.set(refinedProperties, [_prop], _properties[_prop]);
                _horizons1_2.splice(_index, 1);
            }else{
                _.set(orphanedProperties, [_prop], _properties[_prop]);
            }
        })
        Object.keys(orphanedProperties).forEach((_prop:any, _index:number) => {
            _.set(refinedProperties, [_horizons1_2[_index]], _.get(orphanedProperties, [_prop]));
        })
        //console.log("F112723 vetProperties > refinedProperties", refinedProperties)
        //console.log("F112723 vetProperties > orphanedProperties", orphanedProperties)
        return refinedProperties;
    }

    const {data: dataHorizons, loading: loadingHorizons} = useQuery(GET_SOIL_HORIZONS_BY_FIELD_ID, {
        variables: {field_id: fieldId },
        onCompleted: (data) => {
            //console.log("122023 data", data);
            //console.log("122023 dataSources", dataSources);
            //data.landscan_soilprofilesets[0].horizons_mapping["horizon sets"] = []; 
            //console.log("022123 data", data);
            //console.log("022123 year", year);
            
            setHorizonsMappingData(data);
            setHorizonsMapping(data);
        }
    })
    
    const setHorizonsMapping = (data: any) => {
        if (data.landscan_soilprofilesets && data.landscan_soilprofilesets.length > 0){
            let yearProfileSet = data.landscan_soilprofilesets.filter((f: any) => {
                console.log("B082024 f",f)
                if (f.date_sampled?.slice(0, 4) === year){
                    return f;
                }
            })[0];
            console.log("B082024 yearProfileSet", yearProfileSet);
            if (yearProfileSet){
                if (yearProfileSet?.horizons_mapping['horizon sets']){
                    if (Object.keys(yearProfileSet.horizons_mapping['horizon sets']).length === 0){
                        console.log("100125 YYY setHorizonSelected(null) ");
                        //setHorizonSelected(null);
                        setHorizons({"No horizons available":[{"id":"none","top":"","bottom":"","psi":""}]})
                        setProperties(null);
                        /*setProperties(yearProfileSet.horizons_mapping['properties'] 
                            ? yearProfileSet.horizons_mapping['properties'] 
                            : {"30 cm horizons":[], "Root limited horizons":[]} 
                        )*/
                    }else{
                        const horizonSets = yearProfileSet.horizons_mapping['horizon sets'];
                        const horizons1 = Object.keys(horizonSets[0])[0];
                        const horizons2 = Object.keys(horizonSets[1])[0];
                        console.log("x022123 setHorizons horizons1", horizons1);
                        console.log("x022123 setHorizons horizons2", horizons2);
                        console.log("x022123 setHorizons horizonSets[0][horizons1]", horizonSets[0][horizons1]);
                        console.log("x022123 setHorizons horizonSets[1][horizons2]", horizonSets[1][horizons2]);
                        console.log("x022123 setHorizons b");
                        setHorizons({
                            [horizons1]:horizonSets[0][horizons1],
                            [horizons2]:horizonSets[1][horizons2]
                        });
                        //setProperties(vetProperties({"30 cm horizons":[2539,2540],"Root limited horizons":[2562,2563]}, [horizons1, horizons2])) // For testing
                        setProperties(vetProperties(yearProfileSet.horizons_mapping.properties, [horizons1, horizons2]))
                        if (!horizonSelected){
                            console.log("100125 A setHorizonSelected(horizonSets[0][horizons1][0].id) ", horizonSets[0][horizons1][0].id);
                            setHorizonSelected(horizonSets[0][horizons1][0].id);
                            onHorizonMappingChange({target:{value:horizonSets[0][horizons1][0].id}});
                        } 
                    }
                }else{
                    console.log("100125 setHorizonSelected( c");
                    //setHorizonSelected(null);
                    setProperties(null);
                    setHorizons({"No horizons available":[{"id":"none","top":"","bottom":"","psi":""}]})    
                }
            }else{
                console.log("100125 setHorizonSelected( d");
                //setHorizonSelected(null);
                setProperties(null);
                setHorizons({"No horizons available":[{"id":"none","top":"","bottom":"","psi":""}]})
            }
        }else{
            console.log("100125 setHorizonSelected( e");
            //setHorizonSelected(null);
            setProperties(null);
            setHorizons({"No horizons available":[{"id":"none","top":"","bottom":"","psi":""}]})
        }
    }

    const layerRef = useRef<DataSourceMapLayer | null>(null);

    let { dataSources: rawDataSources, loading} = useSoilHorizonDataSources(horizonSelected);

    useEffect(() => {
        // DO NOT set dataSources here. Wait for max/min enrichment.
        console.log("H090424 SoilDataSourceLayer > useEffect > rawDataSources", rawDataSources);
        if (rawDataSources.length > 0){
            setDataSourceInitialLoad(true);
        } else if (!loading) {
            // Clear if empty to avoid zombie UI
            setDataSources([]);
        }
    }, [loading, rawDataSources, dataSourcesUpdate]);

    useEffect(() => {
        console.log("A121523 field", field);
        setDataSourceMaxMinLoad(false);
        setMaxMinInitialLoad(false);
        //setDataSourceInitialLoad(false);
        console.log("122023 rawDataSources", rawDataSources);
        //setDataSourcesUpdate((prevState:number) => {
        //    return prevState + 1;
        //});
    }, [field, selectedSeason]);

    const prevDeps = useRef<{
        horizonsMappingData: any;
        dataSourceInitialLoad: any;
        selectedSeason: any;
        year: any;
        readyToLoadSoilHorizonData: any;
    }>();
    useEffect(() => {      
        const prev = prevDeps.current;

        if (prev) {
            if (prev.horizonsMappingData !== horizonsMappingData) {
            console.log("AA092225 horizonsMappingData changed:", {
                from: prev.horizonsMappingData,
                to: horizonsMappingData,
            });
            }
            if (prev.dataSourceInitialLoad !== dataSourceInitialLoad) {
            console.log("AA092225 dataSourceInitialLoad changed:", {
                from: prev.dataSourceInitialLoad,
                to: dataSourceInitialLoad,
            });
            }
            if (prev.selectedSeason !== selectedSeason) {
            console.log("AA092225 selectedSeason changed:", {
                from: prev.selectedSeason,
                to: selectedSeason,
            });
            }
            if (prev.year !== year) {
            console.log("AA092225 year changed:", { from: prev.year, to: year });
            }
            if (prev.readyToLoadSoilHorizonData !== readyToLoadSoilHorizonData) {
            console.log("AA092225 readyToLoadSoilHorizonData changed:", {
                from: prev.readyToLoadSoilHorizonData,
                to: readyToLoadSoilHorizonData,
            });
            }
        }

        prevDeps.current = {
            horizonsMappingData,
            dataSourceInitialLoad,
            selectedSeason,
            year,
            readyToLoadSoilHorizonData,
        };
        console.log("A091625 selectedSeason", selectedSeason);  
        console.log("A091625 year", year);  
        console.log("AAA091625 horizonsMappingData", horizonsMappingData);  
        console.log("A091625 dataSources", dataSources);  
        console.log("AAA091625 rawDataSources", rawDataSources);  
        console.log("A091625 dataSourceInitialLoad", dataSourceInitialLoad);  
        console.log("A091825 readyToLoadSoilHorizonData", readyToLoadSoilHorizonData);  
        console.log("A092225 horizonsMappingData, rawDataSources, readyToLoadSoilHorizonData", horizonsMappingData, rawDataSources, readyToLoadSoilHorizonData);
        console.log("A092225 horizonsMappingData, dataSourceInitialLoad, selectedSeason, year, readyToLoadSoilHorizonData", horizonsMappingData, dataSourceInitialLoad, selectedSeason, year, readyToLoadSoilHorizonData);
        if (horizonsMappingData && rawDataSources.length > 0 && readyToLoadSoilHorizonData){
            console.log("AAA091625 horizonsMappingData", horizonsMappingData);
            console.log("AAA091625 dataSources", dataSources);
            console.log("AA092225 horizonsMappingData, rawDataSources, readyToLoadSoilHorizonData", horizonsMappingData, rawDataSources, readyToLoadSoilHorizonData);
            console.log("AA092225 -----------------------------> ");
            let horizonsForSeason = horizonsMappingData?.landscan_soilprofilesets.filter((f: any) => {
                console.log("AAA091625 f", f);
                if (f.date_sampled?.slice(0, 4) === selectedSeason){
                    return f;
                }
            });
            console.log("AAA091625 horizonsForSeason", horizonsForSeason);/*OLD VERSION*/
            let _dataSources = rawDataSources.filter((f: any) => {
                /*OLD VERSION for (let p in horizonsMappingData?.landscan_soilprofilesets[0]?.horizons_mapping?.properties) {
                    if (horizonsMappingData.landscan_soilprofilesets[0].horizons_mapping.properties[p].includes(f.property_id)){ */
                for (let p in horizonsForSeason[0]?.horizons_mapping?.properties) {
                    //console.log("B082024 p", p);
                    if (horizonsForSeason[0].horizons_mapping.properties[p].includes(f.property_id)){
                        return f;
                    }
                }
            });
            console.log("AAA091625 _dataSources", _dataSources);
            const promises = _dataSources.map(async (f: any, index:number) => {
                let fCopy = _.cloneDeep(f);
                /*OLD VERSION//console.log("B121423 f", f);
                let maxMin = await queryFieldMaxMin(f);
                //console.log("B121423 maxMin", maxMin);*/
                console.log("A040225 f", fCopy);
                let unfilteredMaxMin = await queryFieldMaxMin(fCopy);
                // FOR TESTING let unfilteredMaxMin = index === 1 ? null : await queryFieldMaxMin(f);
                //console.log("EE021524 f", f);
                console.log("A040225 unfilteredMaxMin", unfilteredMaxMin);
                if (unfilteredMaxMin !== null){ 
                    let maxMin = unfilteredMaxMin.filter((d: any) => {
                        console.log("H090424 d", d);
                        if (d.field_time?.slice(0, 4) === selectedSeason){
                            return d;
                        }
                    })[0];
                    // ORIGINAL LOGIC
                        // f.source["field_max"] = maxMin ? maxMin[`${f.name}_max`] : null;
                        // f.source["field_min"] = maxMin ? maxMin[`${f.name}_min`] : null;
                    // PRIOR TO 04/02/25 LOGIC
                        /*f.source["field_max"] = maxMin ? (maxMin[`${f.name}_mean`] + (maxMin[`${f.name}_stdev`])) : null;
                        f.source["field_min"] = maxMin 
                            ? ((maxMin[`${f.name}_mean`] - (maxMin[`${f.name}_stdev`])) > 0) 
                                ? (maxMin[`${f.name}_mean`] - (maxMin[`${f.name}_stdev`])) 
                                : 0 
                            : null;*/
                    // AFTER TO 04/02/25 LOGIC
                        // min = (mean - sd) > min ? (mean - sd) : min;
                        // max = (mean + sd) < max ? (mean + sd) : max;
                        if (maxMin){
                            fCopy.source["field_min"] = (maxMin[`${fCopy.name}_mean`] - 3 * maxMin[`${fCopy.name}_stdev`]) > maxMin[`${fCopy.name}_min`]
                                ? (maxMin[`${fCopy.name}_mean`] - 3 * maxMin[`${fCopy.name}_stdev`])
                                : maxMin[`${fCopy.name}_min`];
                            fCopy.source["field_max"] = (maxMin[`${fCopy.name}_mean`] + 3 * maxMin[`${fCopy.name}_stdev`]) < maxMin[`${fCopy.name}_max`]
                                ? (maxMin[`${fCopy.name}_mean`] + 3 * maxMin[`${fCopy.name}_stdev`])
                                : maxMin[`${fCopy.name}_max`];
                        }else{
                            fCopy.source["field_max"] = null;
                            fCopy.source["field_min"] = null;        
                        }
                }else{
                    fCopy.source["field_max"] = null;
                    fCopy.source["field_min"] = null;        
                }
                return fCopy;
            });
            
            Promise.all(promises).then(results => {
                console.log("100125 All async operations completed > results", results);
                setDataSources(results);
                setDataSourceMaxMinLoad(true);
                /*setUpdateSoilsKey((prevState:number) => {   
                    return prevState + 1;
                });*/
                // Handle the results as needed, and reset state for field update or season change
                if (context !== "soilsView"){
                    setReadyToLoadSoilHorizonData(false);
                }   
            }).catch(error => {
                console.error("An error occurred in the async operations", error);
            });
        }
    }, [horizonsMappingData, dataSourceInitialLoad, selectedSeason, year, readyToLoadSoilHorizonData]);

    useEffect(() => {
        //console.log("C121423 SoilDataSourceLayer > useEffect > dataSources", dataSources);
        if (dataSources.length > 0 && !maxMinInitialLoad){
            let _dataSources = dataSources.filter((f: any) => {
                if (f.max && f.min){
                    return f;
                }
            });
            //console.log("C121423 _dataSources", _dataSources);
            if (_dataSources.length === dataSources.length){
                setMaxMinInitialLoad(true);
            }
        }
    }, [maxMinInitialLoad]);

    useEffect(() => {
        console.log("100125 setSelected -- A -- dataSources", dataSources); 
        /*console.log("F112723 SoilDataSourceLayer > useEffect > dataSources", dataSources);
        const vvv = dataSources.find((ds: any) => {
            console.log("F112723",  ds.name, ds.property_id);
            if ([2481, 2478, 2502, 3522].includes(ds.property_id)){
                console.log("F112723",  ds.name, ds.property_id);
                return ds;
            }
        });
        console.log("F112723 vvv", vvv);*/
        if(/*!layerRef.current &&*/ dataSources.length) {
            //layerRef.current = new DataSourceMapLayer("soils", "Soils", false, dataSources[0], {});

            console.log("100125 setSelected -- A", dataSources[0]);
            console.log("100125 setSelected -- A selected", selected);
            let ds1 = { ...dataSources[0], uuid: uuidv4() };
            let matchingSource = selected ? dataSources.find((source) => source.id === selected.id) : null;
            
            if (!matchingSource){
                setSoilRasterDataSources([ds1]);
                setSelected(ds1);
            }else{
                let matchingSourceUuid = { ...matchingSource, uuid: uuidv4() };
                setSoilRasterDataSources([matchingSourceUuid]);
                setSelected(matchingSourceUuid);
            }
            //addMapLayer(layerRef.current);
        }
        /*setDataSourcesUpdate((prevState:number) => {
            return prevState + 1;
        });*/
    }, [dataSources]);

    useEffect(() => {
        setSoilRasterDataSourcesForExport?.(dataSources);
    }, [dataSources, setSoilRasterDataSourcesForExport]);

    // useEffect(() => {
    //   console.log("012623 SoilDataSourceLayer > useEffect > dataSources", dataSources);
    //    if(/*!layerRef.current &&*/ dataSources.length) {
            //layerRef.current = new DataSourceMapLayer("soils", "Soils", false, dataSources[0], {});
    //        let ds1 = dataSources[0];
    //        ds1.uuid = uuidv4();
    //        setSoilRasterDataSources([dataSources[0]]);
    //        console.log("040924 setSelected -- B", dataSources[0]);  
    //        setSelected(dataSources[0]);
            //addMapLayer(layerRef.current);
    //    }
    //}, [loading, dataSources]);

    useEffect(() => {
        console.log("022123 selectedSeason", selectedSeason);
        //console.log("110822 SETTING_SEASON_YEAR", SETTING_SEASON_YEAR);
        //const dataSources_loading = useSoilHorizonDataSources(horizonSelected);
        //console.log("110822 dataSources_loading", dataSources_loading);
        //dataSources = dataSources_loading.dataSources;
        //loading =  dataSources_loading.loading;
        //onHorizonMappingChange(null);
    }, [selectedSeason]);

    useEffect(() => {
        console.log("082024 selected", selected)
        if (selected?.source?.color_ramp){
            console.log("082024 selected", selected)
            setGradientParameters(JSON.parse(selected.source.color_ramp))
            setHorizonParameters([
                colorScaleRange === "field" ? selected.source.field_min : selected.source.global_min,
                colorScaleRange === "field" ? selected.source.field_max : selected.source.global_max
            ])
            setUnitParameters([selected.unit ? selected.unit.abbrv : "",selected.unit ? selected.unit.abbrv : ""])
        }
        onHorizonMappingChange(null);
    }, [selected, colorScaleRange, dataSourceMaxMinLoad]);

    const onHorizonMappingChange = (e: any | null ) => {
        console.log("onHorizonMappingChange > 022123 e", e)
        console.log("Z112723 onHorizonMappingChange > e", e)
        let dsLayer: any = null;
        if (e){
            console.log("Z112723 onHorizonMappingChange > e.target.value", e.target.value)
            console.log("Z112723 onHorizonMappingChange > selected", selected)
            console.log("Z112723 onHorizonMappingChange > horizonSelected", horizonSelected)
            console.log("Z112723 onHorizonMappingChange > horizonSelected", dataSources)
            if (properties && (horizonSelected === "D0_RL" || e.target.value === "D0_RL")){
                dsLayer = dataSources.find((source: DataSourceRasterLayer) => {
                    if (e.target.value === "D0_RL"){
                        if (properties[Object.keys(properties)[1]].includes(source.property_id)){
                            return source;
                        }
                    }else{
                        if (properties[Object.keys(properties)[0]].includes(source.property_id)){
                            return source;
                        }
                    }
                });
            }
            console.log("100125 ??? setHorizonSelected(e.target.value)` ", e.target.value);
            setHorizonSelected(e.target.value)
        }
        if(!dsLayer) {
            if (!dataSources /*|| !layerRef.current*/) return;
            //const layer = layerRef.current;
            dsLayer = dataSources.find((ds: any/*DataSourceRasterLayer*/) => {
                return ds.id === selected?.id; //layerRef?.current?._source.id;
            });
        }

        if(dsLayer) {
            const source = dsLayer.source;
            //if (layer){
                dsLayer.tiles = getTileUrlTemplate(
                    source,
                    source.stac_address!, 
                    source.collection_id!,
                    'footprint_id',
                    `${selectedSeason}-01-01`,//source.min_date,
                    `${selectedSeason}-12-31`,//source.max_date,
                    source.date_display_resolution!,
                    "template-seasonrange",
                    e ? e.target.value : horizonSelected,
                    colorScaleRange
                )
                dsLayer.uuid = uuidv4();
                //layer.updateDataSource(dsLayer);
                setSoilRasterDataSources([dsLayer]);
                console.log("100125 setSelected -- C", dsLayer);  
                setSelected(dsLayer);
                refresh();
            //}
        }
    }

    const queryFieldMaxMin = async (dsLayer: any) => {
        console.log("A102824 dsLayer", dsLayer);
        const definition = state.definitions.find((d:Definition) => d.name.toLowerCase().includes('field'));
        console.log("A102824 definition", definition);
        console.log("A102824 field", field);
        if(!definition) {
            console.error('Unable to find field definition');
            console.log("A102824 Unable to find field definition");
            return null;
        }
        //console.log("D121523 definition - ", definition);
        //console.log("D121523 ddsLayer - ", dsLayer);
        return await _load(field.entityId!, settings[SETTING_SEASON_YEAR], dsLayer, definition).then(result => { 
            console.log("A102824 result", result);
            //setData(result);
            //setDataLoading(false);
            //cache[key] = result;
            if (result) {
                return result;
            }else{
                console.log("A102824 fail - ", dsLayer.name);
                return null;
            }
        });
        //return null;
    }

    const _load = async (extId: number, year: number, layer: any, definition: Definition) => {
        const dtStart = `${year}-01-01 12:00:00.00`;
        const dtEnd = `${year}-12-31 23:59:59.59`;
        console.log("B082024 dtStart", dtStart)
        console.log("B082024 dtEnd", dtEnd)
        console.log("BB102824 layer", layer)
        const data = await queryDwSoilMaxMin(extId, definition, layer, dtStart, dtEnd);
        console.log("BB102824 data", data)
        if(data) {
            return data;
        }

        return null;
    }

    const localize = (v: any) => {
        return v === "Root limiting" 
        ? v
        : preferredAreaSmall 
            ? preferredAreaSmall == "cm" 
                ? v 
                : (v / 2.5) 
            : v;
    }

    const onSourceChange = (e: any) => {
        console.log("100125 onSourceChange e", e);
        console.log("100125 onSourceChange e.target", e.target);
        console.log("100125 onSourceChange e.target.value", e.target.value);
        if(!dataSources /*|| !layerRef.current*/) return;
        setPropertySelected(e.target.value);
        const dsLayer = dataSources.find((ds: DataSourceRasterLayer) => {
            return ds.id === e.target.value;
        });

        if(dsLayer) {
            //const layer = layerRef.current;
            //layer.updateDataSource(dsLayer);
            console.log("121423 dsLayer", dsLayer);
            console.log("121423 properties", properties);
            console.log("horizonSelected", horizonSelected);
            console.log("horizons", horizons);
            if ((!properties[Object.keys(properties)[0]].includes(dsLayer.property_id)) && (properties[Object.keys(properties)[1]].includes(dsLayer.property_id))){
                console.log("100125 XX setHorizonSelected('D0_RL')");
                setHorizonSelected("D0_RL")
            }
            dsLayer.uuid = uuidv4();
            setSoilRasterDataSources([dsLayer])
            console.log("100125 setSelected -- D", dsLayer);  
            setSelected(dsLayer);
            refresh();
        }
    }

    return (
        <div key={"soilDataSourceLayer_key"} className="d-flex flex-column mb-2 border p-2 rounded text-sm">
            <div className="d-flex justify-content-between">
                <Form.Check 
                    type="checkbox"
                    label="Soil Horizon Layers"
                    checked={visible}
                    onChange={() => {
                        const nextState = !visible;
                        //if(layerRef.current) {
                        //    layerRef.current.visible = nextState;
                        //}
                        setSoilRasterVisibility(nextState);
                        setVisible(nextState);
                        refresh();
                    }}
                    key={"soil-raster-visibility"}
                />
                <Button 
                    className="rounded-circle" variant="light" size="sm" title="Layer settings" 
                    onClick={(e: any) => {
                    if (setShowLayerSettings){
                        setShowLayerSettings((prevState:boolean) => {
                        return !prevState;
                        });
                    }
                    }}
                    style={{cursor:'pointer', height:'30px', width:'30px', padding:'0.25rem 0.375rem'}}
                >
                    <FontAwesomeIcon icon={faCog} />
                </Button>
            </div>
            {showLayerSettings
                ? <LayerSettings 
                    onCancel={() => setShowLayerSettings(false)}
                    colorScaleRange={colorScaleRange}
                    setColorScaleRange={setColorScaleRange}
                ></LayerSettings>
                : null
            }
            <div key={"k2"} className="d-flex mt-3">
                <Form.Control as="select"
                    size="sm"
                    onChange={(e: any) => onHorizonMappingChange(e)}
                    value={horizonSelected ? horizonSelected : undefined}
                    key={"horizon-selector-k2"}> 
                    {
                        horizons["No horizons available"] 
                            ? <option key={"none"} value={undefined}>No horizons available</option>
                            : Object.entries(horizons).map((horizonIntervalSet:any, indexInterval:number) => (
                                properties
                                    ?  (
                                        console.log("A082825 horizonIntervalSet", horizonIntervalSet),
                                       /* console.log("A112723 properties", properties),
                                        console.log("A112723 horizons", horizons),
                                        console.log("A112723 horizonIntervalSet", horizonIntervalSet),
                                        console.log("B112723 properties[horizonIntervalSet[0]]", properties[horizonIntervalSet[0]]),
                                        console.log("B112723 horizonIntervalSet[0]", horizonIntervalSet[0]),
                                        console.log("B112723 properties[horizonIntervalSet[1]]", properties[horizonIntervalSet[1]]),
                                        console.log("B112723 horizonIntervalSet[1]", horizonIntervalSet[1]),
                                        console.log("Z112723 selected", selected),
                                        console.log("Z112723 selected?.property_id", selected?.property_id),*/
                                    //properties[horizonIntervalSet[0]].includes(selected?.property_id) // check if the horizon category should be included (30 cm horizons OR Root limited horizons)
                                    true
                                        ? <optgroup key={`k2_${indexInterval}_category_horizon`} label={
                                            horizonIntervalSet[0] ===  "10 cm horizons"
                                                ? preferredAreaSmall == 'in' ? "4 in horizons" : "10 cm horizons"
                                                : horizonIntervalSet[0]
                                        }>{
                                            Object.entries(horizonIntervalSet[1]).map((horizon:any, index:number) => (
                                                <option 
                                                    key={`k2_${horizon[1].id}_${index}_horizon`} 
                                                    value={horizon[1].id}
                                                    disabled={horizon[1].id === "none" ? true : false}
                                                >
                                                    {horizon[1].id === "none" ? "No horizons available" : (`${localize(horizon[1].top)}-${localize(horizon[1].bottom)}${ 
                                                            horizonIntervalSet[0] ===  "10 cm horizons"
                                                                ? preferredAreaSmall == 'in' ? ' in' : ' cm' 
                                                                : ""
                                                        }`)}
                                                </option>
                                            ))}
                                        </optgroup>
                                        : <optgroup key={`k2_${indexInterval}_category_horizon`} label={horizonIntervalSet[0]} disabled>{
                                            <option key={`${"f"}_${"x"}_horizon`} value={"fx"}>{"No horizons available" }</option>
                                        }
                                        </optgroup>)
                                    : (dataSources.length >= 1) 
                                        ? <optgroup key={`k2_${indexInterval}_category_horizon`} label={horizonIntervalSet[0]}>{
                                            Object.entries(horizonIntervalSet[1]).map((horizon:any, index:number) => (
                                                <option 
                                                    key={`k2_${horizon[1].id}_${index}_horizon`} 
                                                    value={horizon[1].id}
                                                    disabled={horizon[1].id === "none" ? true : false}
                                                >
                                                    {horizon[1].id === "none" ? "No horizons available" : (`${localize(horizon[1].top)}-${localize(horizon[1].bottom)}`)}
                                                </option>
                                            ))}
                                        </optgroup>
                                        : <optgroup key={`k2_${indexInterval}_category_horizon`} label={horizonIntervalSet[0]} disabled>{
                                                <option key={`${"f"}_${"x"}_horizon`} value={"fx"}>{"No horizons available" }</option>
                                            }
                                        </optgroup>
                            ))
                    }
                </Form.Control>
                </div>
            <div key={"k1"} className="d-flex mt-3">
                <Form.Control as="select"
                    size="sm"
                    onChange={(e: any) => onSourceChange(e)}
                    value={selected ? selected.id : undefined}
                    key={"property-selector-k1"}>  
                    {/*console.log("F112723 properties", properties)}
                    {console.log("F112723 horizons", horizons)}
                    {console.log("F112723 dataSources", dataSources)*/}
                    { dataSources.length < 1 || !properties
                        ? <option key={"none"} value={undefined}>No soil layers available</option>
                        : dataSources.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase())).map(source => (
                            properties
                                ? //<option key={`k1_${source.id}_k1b`} value={source.id} id={(source.property_id ? source.property_id : 999).toString()}>{source.name}</option>
                                    /* FILTER OUT PROPERTIES THAT DO NOT HAVE SELECTED HORIZON*/
                                    horizonSelected === "D0_RL"
                                    ? properties[Object.keys(properties)[1]].includes(source.property_id) 
                                        ? <option key={`k1_${source.id}_k1a`} value={source.id} id={(source.property_id ? source.property_id : 999).toString()}>{source.name}</option>
                                        : null
                                    : properties[Object.keys(properties)[0]].includes(source.property_id) 
                                        ? <option key={`k1_${source.id}_k1b`} value={source.id} id={(source.property_id ? source.property_id : 999).toString()}>{source.name}</option>
                                        : null
                                //: <option key={`k1_${source.id}_k1b`} value={`${source.id}_k1c`} id={(source.property_id ? source.property_id : 999).toString()}>{source.name}</option>
                                : null
                            ))
                        }
                </Form.Control>
            </div>
            {console.log("082024 gradientParameters",gradientParameters)}
            {console.log("082024 unitParameters",unitParameters)}
            {console.log("082024 horizonParameters",horizonParameters)}
            <div key={"k3"} className="mt-3">
                    <div style={{width: "100%", height: 40, textAlign: "center", }}>
                        <Gradient width={rampWidth} height={15} ramp={gradientParameters} inverse={false} />
                        <br/>
                        <div style={{height: 15, width:rampWidth, display:'inline-block'}}>
                            <div style={{float:'left'}}>{`${(horizonParameters[0]!==undefined && horizonParameters[0]!==null) ? dcRound(horizonParameters[0]).toString() : ""}${(unitParameters[0]!==undefined && unitParameters[0]!==null) ? unitParameters[0] == '%' ? unitParameters[0] : " " + unitParameters[0] : "" }`}</div>
                            <div style={{float:'right'}}>{`${(horizonParameters[1]!==undefined && horizonParameters[1]!==null) ? dcRound(horizonParameters[1]).toString() : ""}${(unitParameters[0]!==undefined && unitParameters[0]!==null) ? unitParameters[1] == '%' ? unitParameters[1] : " " + unitParameters[1] : ""}`}</div>
                        </div>
                    </div>
                </div>
        </div>
    );
}

export default SoilDataSourceLayer;
